










import { Component, Prop, Vue } from "vue-property-decorator";
import { GasyaResultUnit } from "@/constants";
import AwaikenUnitComponent from "@/components/AwaikenUnitComponent.vue";

@Component({
  components: {
    AwaikenUnitComponent,
  },
})
export default class AwaikenUnitsComponent extends Vue {
  @Prop() result!: GasyaResultUnit[];
  @Prop() awaikingNums!: number[];
  idx = 0;
  get currentUnit() {
    return this.result[this.idx];
  }
  get awaikingNum() {
    return this.awaikingNums[this.idx];
  }
  next() {
    this.idx++;
    if (this.idx >= this.result.length) {
      this.$emit("done");
      this.$destroy();
    }
  }
}
